import { executeShopifyMutation } from '../ShopifyApiRequest'
import { CART_FRAGMENT } from '../ShopifyApiRequest/CartFragment.js'

const APPLY_DISCOUNT_MUTATION = `
  mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        ${CART_FRAGMENT}
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const applyDiscountToCart = async (cartId, code) =>
  executeShopifyMutation(
    APPLY_DISCOUNT_MUTATION,
    {
      cartId,
      discountCodes: [code],
    },
    'cartDiscountCodesUpdate'
  )
